import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-vuilnisbak',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconVuilnisbak {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M9.99 29h3v5c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1zm12 0h3v5c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1zm4.25-26.28C26.1 1.73 25.25 1 24.26 1H10.73c-1 0-1.84.73-1.98 1.72L8 8l.9 17.1c.06 1.06.93 1.9 2 1.9h13.2c1.06 0 1.94-.83 2-1.9L27 8l-.75-5.28ZM23.99 7.6c0 1.33-.9 2.4-2 2.4h-9c-1.1 0-2-1.07-2-2.4V6.4c0-1.33.9-2.4 2-2.4h9c1.1 0 2 1.07 2 2.4z"/>
</svg>

    );
  }
}
